import styles from './Button.module.css';

// Варианты: 'primary' | 'secondary' | 'outline'
// Размеры: 'md' (по умолчанию) | 'lg' | 'sm'
const Button = ({ children, variant = 'primary', size = 'md', className = '', ...props }) => {
  const classes = [
    styles.button,
    styles[variant],
    styles[size],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;
